import React from 'react';
import Relay from 'react-relay/classic';
import PropTypes from 'prop-types';

import get from 'lodash.get';
import mobileCheck from 'dibs-client-check/dist/mobileCheck';
import folderTracking from '../../../favorites/shared/folderTracking.es';
import { CALLOUT_TYPE_SAVE_TO_FOLDER } from '../../../components/Callout/calloutHelper.es';

import FolderWrapperWrapper from '../../../global/components/FolderWrapperWrapper';
import Callout from '../../../components/Callout/Callout';

import styles from './PdpFolderItem-style.scss';
import { copy as calloutCopy } from './PdpFolderItemCallout.json';

function PdpFolderItem(props) {
    const { loadPortfolioData, userId, userIds, selectedItemIds, shouldFillInFolder } = props;
    const title = get(props, 'item.title');
    const image = get(props, 'item.photos[0].versions[0].webPath');

    const pdpFolderItemRelayVariables = {
        loadPortfolioData,
        userId,
        userIds,
        selectedItemIds,
        singlePortfolioItem: true,
        shouldFillInFolder,
    };

    return (
        <div className={styles.pdpFolderItem} data-tn="item-save-to-folder">
            <FolderWrapperWrapper
                viewer={props.viewer}
                primaryItemPk={props.itemId}
                {...pdpFolderItemRelayVariables}
                selectedItemImages={[image]}
                selectedItemTitles={[title]}
                onAddItemSuccess={props.onAddItemSuccess}
                // tracking
                trackingHooks={folderTracking}
                authModalTrackingLabel="save item - product page"
            />

            {/* SaveToFolder callout */}
            {!mobileCheck.any() ? (
                <Callout
                    callout={props.callout}
                    copy={calloutCopy}
                    type={CALLOUT_TYPE_SAVE_TO_FOLDER}
                />
            ) : null}
        </div>
    );
}

PdpFolderItem.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string.isRequired,
        photos: PropTypes.arrayOf(
            PropTypes.shape({
                versions: PropTypes.arrayOf(
                    PropTypes.shape({
                        webPath: PropTypes.string.isRequired,
                    }).isRequired
                ).isRequired,
            }).isRequired
        ).isRequired,
    }),
    userId: PropTypes.string,
    userIds: PropTypes.arrayOf(PropTypes.string),
    loadPortfolioData: PropTypes.bool.isRequired,
    shouldFillInFolder: PropTypes.bool.isRequired,
    selectedItemIds: PropTypes.arrayOf(PropTypes.string),
    itemId: PropTypes.string,
    viewer: PropTypes.object,
    callout: PropTypes.object,
    onAddItemSuccess: PropTypes.func,
};

export default Relay.createContainer(PdpFolderItem, {
    initialVariables: {
        userId: null,
        userIds: [],
        selectedItemIds: [],
        loadPortfolioData: false,
        shouldFillInFolder: false,
    },
    fragments: {
        viewer: params => Relay.QL`
                fragment on Viewer {
                    ${FolderWrapperWrapper.getFragment('viewer', params)}
                }
            `,
        item: () => Relay.QL`
                fragment on Item {
                    title
                    photos {
                        versions {
                            webPath
                        }
                    }   
                }
            `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Favorites/PdpFolderItem.jsx